import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScientist = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 312,
	height: 372,
	viewBox: "0 0 312 372",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3710_46677)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M94.6491 122.934C99.2511 122.934 102.982 126.608 102.982 131.141C102.982 135.673 99.2511 139.348 94.6491 139.348C90.0471 139.348 86.3164 135.673 86.3164 131.141C86.3164 126.608 90.0471 122.934 94.6491 122.934Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.6491 127.584C96.6483 127.584 98.269 129.176 98.269 131.141C98.269 133.106 96.6483 134.698 94.6491 134.698C92.65 134.698 91.0293 133.106 91.0293 131.141C91.0293 129.176 92.65 127.584 94.6491 127.584Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.6452 81.6501C40.6444 81.6501 42.2651 83.2427 42.2651 85.2074C42.2651 87.172 40.6444 88.7646 38.6452 88.7646C36.6461 88.7646 35.0254 87.172 35.0254 85.2074C35.0254 83.2427 36.6461 81.6501 38.6452 81.6501Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M310.897 207.227C315.499 207.227 319.23 210.901 319.23 215.434C319.23 219.966 315.499 223.641 310.897 223.641C306.295 223.641 302.564 219.966 302.564 215.434C302.564 210.901 306.295 207.227 310.897 207.227Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M310.897 211.877C312.896 211.877 314.517 213.469 314.517 215.434C314.517 217.399 312.896 218.991 310.897 218.991C308.898 218.991 307.277 217.399 307.277 215.434C307.277 213.469 308.898 211.877 310.897 211.877Z",
				fill: "#40C676",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.198 82.1508C168.8 82.1508 172.531 85.8251 172.531 90.3576C172.531 94.8901 168.8 98.5645 164.198 98.5645C159.596 98.5645 155.865 94.8901 155.865 90.3576C155.865 85.8251 159.596 82.1508 164.198 82.1508Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M164.198 86.8005C166.197 86.8005 167.818 88.3931 167.818 90.3578C167.818 92.3224 166.197 93.915 164.198 93.915C162.199 93.915 160.578 92.3224 160.578 90.3578C160.578 88.3931 162.199 86.8005 164.198 86.8005Z",
				fill: "#40C676",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M212.319 164.248C216.921 164.248 220.652 167.923 220.652 172.455C220.652 176.988 216.921 180.662 212.319 180.662C207.717 180.662 203.986 176.988 203.986 172.455C203.986 167.923 207.717 164.248 212.319 164.248Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M212.319 168.898C214.318 168.898 215.939 170.491 215.939 172.455C215.939 174.42 214.318 176.013 212.319 176.013C210.32 176.013 208.699 174.42 208.699 172.455C208.699 170.491 210.32 168.898 212.319 168.898Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.354 150.07C255.956 150.07 259.687 153.744 259.687 158.277C259.687 162.809 255.956 166.483 251.354 166.483C246.752 166.483 243.021 162.809 243.021 158.277C243.021 153.744 246.752 150.07 251.354 150.07Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M251.354 154.719C253.353 154.719 254.974 156.312 254.974 158.277C254.974 160.241 253.353 161.834 251.354 161.834C249.355 161.834 247.734 160.241 247.734 158.277C247.734 156.312 249.355 154.719 251.354 154.719Z",
				fill: "#40C676",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-4 97L35 87",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.6191 92.1515L89.875 124.127",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.658 126.702L157.159 95.2878",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M167.867 97.6926L207.605 166.213",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M219.447 167.767L243.523 161.103",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M306.406 208.319L256.811 164.419",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M220.581 291.934C215.979 291.934 212.249 295.608 212.249 300.141C212.249 304.673 215.979 308.348 220.581 308.348C225.183 308.348 228.914 304.673 228.914 300.141C228.914 295.608 225.183 291.934 220.581 291.934Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M220.581 296.584C218.582 296.584 216.961 298.176 216.961 300.141C216.961 302.106 218.582 303.698 220.581 303.698C222.581 303.698 224.201 302.106 224.201 300.141C224.201 298.176 222.581 296.584 220.581 296.584Z",
				fill: "#40C676",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.585 246C271.983 246 268.253 249.675 268.253 254.207C268.253 258.74 271.983 262.414 276.585 262.414C281.187 262.414 284.918 258.74 284.918 254.207C284.918 249.675 281.187 246 276.585 246Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M276.585 250.65C274.586 250.65 272.965 252.243 272.965 254.207C272.965 256.172 274.586 257.765 276.585 257.765C278.584 257.765 280.205 256.172 280.205 254.207C280.205 252.243 278.584 250.65 276.585 250.65Z",
				fill: "#40C676",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M151.033 251.151C146.431 251.151 142.7 254.825 142.7 259.358C142.7 263.89 146.431 267.564 151.033 267.564C155.635 267.564 159.365 263.89 159.365 259.358C159.365 254.825 155.635 251.151 151.033 251.151Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M151.032 255.8C149.033 255.8 147.413 257.393 147.413 259.358C147.413 261.322 149.033 262.915 151.032 262.915C153.032 262.915 154.652 261.322 154.652 259.358C154.652 257.393 153.032 255.8 151.032 255.8Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M102.911 333.248C98.3095 333.248 94.5788 336.923 94.5788 341.455C94.5788 345.988 98.3095 349.662 102.911 349.662C107.513 349.662 111.244 345.988 111.244 341.455C111.244 336.923 107.513 333.248 102.911 333.248Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M102.911 337.898C100.912 337.898 99.2915 339.491 99.2915 341.455C99.2915 343.42 100.912 345.013 102.911 345.013C104.911 345.013 106.531 343.42 106.531 341.455C106.531 339.491 104.911 337.898 102.911 337.898Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.8763 319.07C59.2743 319.07 55.5436 322.744 55.5436 327.277C55.5436 331.809 59.2743 335.483 63.8763 335.483C68.4783 335.483 72.209 331.809 72.209 327.277C72.209 322.744 68.4783 319.07 63.8763 319.07Z",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .9,
				d: "M63.8762 323.719C61.8771 323.719 60.2564 325.312 60.2564 327.277C60.2564 329.241 61.8771 330.834 63.8762 330.834C65.8754 330.834 67.4961 329.241 67.4961 327.277C67.4961 325.312 65.8754 323.719 63.8762 323.719Z",
				fill: "#40C676",
				fillOpacity: .5,
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M319.23 266.081L284.406 257.043",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M271.611 261.151L225.355 293.127",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M213.572 295.702L158.071 264.288",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M147.363 266.693L107.625 335.213",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M95.7832 336.767L71.7077 330.103",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.82495 377.319L58.4199 333.419",
				stroke: "#006ADC",
				strokeOpacity: .5,
				strokeWidth: .91,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104.606 23.3586C104.606 23.3586 104.606 3.91283 67.2142 16.8179C34.8141 27.997 44.5322 51.3457 32.2448 89.0312C17.045 135.64 53.5932 151.605 70.9897 147.369L106.332 145.937L115.785 101.72L104.616 23.3684L104.606 23.3586Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M103.221 24.2722L103.22 24.2725L103.209 24.4791L103.245 24.5199L110.171 104.82L98.0516 148.91L62.0937 148.334L62.0442 148.333L61.9956 148.342C53.1264 149.967 39.6291 146.263 30.6178 136.368C21.6468 126.518 17.0726 110.465 26.1566 87.2789L25.691 87.0966L26.1566 87.2789C29.8639 77.8149 32.102 69.1913 33.9031 61.4425C34.3217 59.6418 34.7162 57.8906 35.0998 56.1883C36.3696 50.5517 37.5187 45.4512 39.0197 40.8641C40.9693 34.9056 43.4978 29.8664 47.6106 25.7272C51.7225 21.5889 57.4535 18.3146 65.8659 15.9491L65.8659 15.9491C85.3778 10.4607 94.6697 12.7211 99.0841 16.1532C101.291 17.8687 102.322 19.9075 102.805 21.5164C103.046 22.3222 103.15 23.0197 103.193 23.5128C103.215 23.7591 103.222 23.9537 103.223 24.0844C103.223 24.1497 103.223 24.199 103.222 24.2307C103.222 24.2466 103.221 24.258 103.221 24.2649L103.221 24.2715L103.221 24.2717L103.221 24.2722Z",
				stroke: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.8503 27.5365C97.8503 27.5365 104.744 15.563 115.688 21.0741C126.887 26.7225 129.299 38.4606 127.495 56.1315C125.239 78.1858 161.444 115.999 112.717 144.682L82.1504 145.927L97.8503 27.5365Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78.9336 154.899C78.9336 154.899 92.4271 184.7 187.215 232.398L213.173 203.626L120.375 140.602L78.9336 154.889V154.899Z",
				fill: "#EBF2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.599 179.454C181.342 188.187 181.519 197.636 181.883 200.181L186.799 186L164.406 170.727C166.591 173.454 165.499 172.363 172.599 179.454Z",
				fill: "#E9EBF0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M213.369 196.262L228.608 126.01L214.349 124.794L194.697 179.846C200.728 185.583 206.955 191.065 213.378 196.262H213.369Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M212.869 122.784L213.016 119.067C213.212 114.076 214.575 109.192 217.007 104.818L221.283 97.1303C222.303 95.3064 224.715 94.8259 226.353 96.1301C227.736 97.2284 228.304 99.0622 227.794 100.759L225.107 109.702L248.496 87.5692C249.614 86.4513 251.457 86.5788 252.418 87.8242L253.065 88.6577C253.83 89.6482 253.781 91.0309 252.967 91.9723L237.777 107.427L257.684 92.0899C258.871 91.0603 260.695 91.2858 261.577 92.59L262.019 93.2373C262.764 94.3356 262.568 95.8065 261.577 96.6793L244.74 111.222L259.949 102.985C261.391 102.141 263.244 102.857 263.754 104.446L263.862 104.769C264.215 105.858 263.813 107.054 262.872 107.711L247.682 117.39L256.635 114.213C258.341 113.32 260.4 114.517 260.469 116.439C260.499 117.361 260.047 118.224 259.283 118.724L220.695 142.631L215.576 133.708C213.673 130.383 212.742 126.598 212.889 122.774L212.869 122.784Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225.105 109.702C225.105 109.702 229.008 115.811 225.841 124.313",
				stroke: "#023B79",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M180.489 204.882L202.396 139.866L230.54 150.584L217.361 220.385C214.399 232.212 201.631 238.654 190.354 234.016C180.205 229.839 175.321 218.257 180.489 204.882Z",
				fill: "#EBF2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M186.697 185.642L181.646 201.214",
				stroke: "#002E5F",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.1135 133.443C65.1135 133.443 42.0294 142.033 34.4197 148.015C26.81 153.997 25.2213 167.186 31.3111 185.445C37.4008 203.705 58.6806 266.112 58.6806 266.112L31.3699 378.374H160.068L142.672 267.72L144.515 235.163C144.515 235.163 156.528 201.645 145.006 174.796C129.061 137.64 100.554 129.354 100.554 129.354L65.1233 133.443H65.1135Z",
				fill: "#EBF2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M100.544 129.354C100.544 129.354 110.468 149.378 117.509 189.544C117.509 189.544 85.5889 162.96 65.1133 133.443L79.7738 129.354H100.544Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_3710_46677",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 65,
				y: 129,
				width: 53,
				height: 62,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M100.983 129.818C100.983 129.818 110.907 149.843 117.948 190.009C117.948 190.009 86.0284 163.424 65.5527 133.908L80.2132 129.818H100.983Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_3710_46677)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M56.7891 157.321C56.7891 157.321 109.096 144.494 134.936 150.868L137.368 199.89L101.986 209.147L74.921 165.941",
					fill: "#ACD4FF"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M117.508 189.534L129.236 218.561L132.227 378.373",
				stroke: "#002E5F",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.977 212.276C149.977 212.276 150.506 184.72 140.484 167.226",
				stroke: "#002E5F",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.2057 146.103C37.2057 146.103 2.86391 157.213 -21.2793 275.604L15.2689 288.568L53.4548 188.76L37.2057 146.093V146.103Z",
				fill: "#EBF2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.4297 224.132L49.2652 199.636",
				stroke: "#002E5F",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.9219 262.2L101.017 262.494L105.645 278.165L39.9231 287.236L34.9219 262.2Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.99189 254.571L73.2938 258.219L70.6265 292.09L-1.10691 297.218C-14.1788 297.16 -23.2202 288.53 -21.2786 275.605C-19.533 263.965 -9.66785 252.914 1.99189 254.561V254.571Z",
				fill: "#EBF2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.08398 254.934L73.2962 258.219L72.9824 262.2",
				stroke: "#002347",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.9282 283.637L70.2711 292.001L45.8926 294.531",
				stroke: "#002E5F",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.569 219.23L103.946 292.414C103.185 295.123 105.219 297.809 108.029 297.809H155.957C157.82 297.809 159.473 296.59 160.017 294.805L182.417 221.62C183.255 218.896 181.214 216.133 178.358 216.133H128.652C126.75 216.133 125.081 217.398 124.569 219.222V219.23Z",
				fill: "#002E5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M148.055 213.789C148.055 213.789 151.462 208.907 159.441 209.505C168.328 210.172 166.877 218.066 166.877 218.066L148.055 213.781V213.789Z",
				fill: "#002E5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M132.516 216.366L115.316 277.396C114.68 279.654 116.38 281.898 118.724 281.898H158.697C160.249 281.898 161.623 280.881 162.081 279.391L180.763 218.361C181.462 216.087 179.754 213.789 177.379 213.789H135.931C134.348 213.789 132.951 214.845 132.524 216.366H132.516Z",
				fill: "#002E5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M127.293 219.23L106.671 292.414C105.91 295.123 107.943 297.809 110.753 297.809H158.682C160.545 297.809 162.198 296.59 162.741 294.805L185.142 221.62C185.98 218.896 183.938 216.133 181.082 216.133H131.376C129.475 216.133 127.806 217.398 127.293 219.222V219.23Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.6508 265.29C94.6508 265.29 97.0534 255.523 117.235 245.756L114.264 256.582C114.264 256.582 123.913 255.14 137.23 248.855C138.485 248.256 139.986 248.776 140.652 250.002C141.378 251.326 140.849 252.993 139.495 253.66L134.827 255.954L142.663 253.993C143.987 253.66 145.33 254.425 145.722 255.729C146.085 256.955 145.497 258.249 144.33 258.779C142.849 259.445 140.27 260.455 135.798 261.877C135.798 261.877 139.544 261.446 143.379 260.759C144.751 260.514 146.085 261.338 146.34 262.711C146.546 263.839 145.967 264.957 144.918 265.417C142.878 266.31 139.181 267.8 134.386 269.252C137.916 269.046 141.839 268.349 142.378 269.654C142.927 270.958 142.829 272.252 132.886 275.077C122.942 277.901 109.527 282.421 100.819 280.274L89.8359 275.734V263.603L94.6508 265.3V265.29Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.903 54.3955C122.197 75.0377 108.046 91.9437 85.8252 92.2575C63.6041 92.5713 45.3447 76.0967 45.0505 55.4546C44.7563 34.8124 62.5352 17.828 84.7563 17.5142C106.978 17.2004 121.609 33.7533 121.893 54.3857L121.903 54.3955Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78.6386 85L73 134.737L99.9968 137.875L97.6728 90.8445L78.6386 85Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M99.6222 123.725C99.6222 123.725 95.7177 113.017 91.2217 107.454C86.5186 101.634 76.3027 95.4241 76.3027 95.4241L98.0728 94.6494L99.6222 123.725Z",
				fill: "#CCB499"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.0706 28.684C86.5918 26.8307 93.515 26.3109 100.154 27.5367C109.146 29.194 120.708 34.4207 122.287 50.2382C124.925 76.6072 120.551 96.4355 107.087 102.672C96.761 107.458 90.4359 105.83 78.4329 99.3479C73.971 96.9356 66.577 88.0315 66.4201 82.7558L61.8504 69.7723C61.8504 69.7723 48.9158 37.5195 80.0608 28.684H80.0706Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M102.912 92.4212C101.073 93.0341 99.0887 92.7966 97.6028 91.7361C96.2658 90.7758 95.4032 89.1963 95.2679 87.4091C95.2609 87.3192 95.3267 87.2397 95.4168 87.2327C95.5068 87.2258 95.5865 87.2914 95.5934 87.3813C95.7322 89.0752 96.5324 90.5717 97.8036 91.4733C99.4731 92.6685 101.846 92.7537 103.83 91.6775C103.91 91.6394 104.01 91.6635 104.048 91.743C104.086 91.8225 104.062 91.9228 103.982 91.9609C103.639 92.1443 103.286 92.2966 102.923 92.4178L102.912 92.4212Z",
				stroke: "#002347",
				strokeWidth: .9,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.1798 66.6325C97.1798 66.6325 89.9421 60.293 83.0326 65.9217",
				stroke: "#002347",
				strokeWidth: .96,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M121.562 64.9681C121.562 64.9681 115.75 59.6044 110.892 67.0853",
				stroke: "#002347",
				strokeWidth: .96,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .15,
				d: "M88.7927 54.5666L101.601 71.9293C101.601 71.9293 97.7365 79.2992 91.5858 78.4827L78.6621 61.5463C78.6621 61.5463 82.1572 54.1042 88.7927 54.5666Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M102.609 68.7287C103.673 61.9278 99.022 55.5523 92.2211 54.4885C85.4202 53.4247 79.0446 58.0756 77.9808 64.8764C76.917 71.6773 81.5679 78.0528 88.3688 79.1166C95.1697 80.1803 101.545 75.5295 102.609 68.7287Z",
				stroke: "#006ADC",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .15,
				d: "M119.049 55.6566L131.443 72.4487C131.443 72.4487 127.759 80.4262 121.807 79.6366L110.338 63.2729C110.338 63.2729 112.628 55.2094 119.049 55.6566Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.758 80.0291C126.981 80.0291 132.025 74.4489 132.025 67.5653C132.025 60.6818 126.981 55.1016 120.758 55.1016C114.535 55.1016 109.49 60.6818 109.49 67.5653C109.49 74.4489 114.535 80.0291 120.758 80.0291Z",
				stroke: "#006ADC",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M109.489 67.2722C109.489 67.2722 106.39 65.1737 102.752 67.1055",
				stroke: "#006ADC",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.8339 66.1836L68.4492 71.4692",
				stroke: "#006ADC",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M107.563 81.9972L110.799 79.379L107.062 74.1816",
				stroke: "#002347",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.4662 63.4572C53.4662 63.4572 102.478 48.6204 96.8299 20.6235C96.8299 20.6235 79.0216 15.8773 64.7828 31.7536C50.5439 47.6299 53.4662 63.4474 53.4662 63.4474V63.4572Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.4104 54.8857V80.4507L56.5938 61.505L68.4104 54.8857Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.1978 74.2032C50.0113 79.2927 53.5514 84.8822 59.1018 86.6964C64.6521 88.5007 70.1045 85.8432 71.291 80.7538C72.4776 75.6643 68.9375 70.0748 63.3871 68.2606C57.8367 66.4563 52.3844 69.1138 51.1978 74.2032Z",
				fill: "#DFD0BF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.5918 74.6733C56.5918 74.6733 62.6325 73.2416 65.8098 79.7628",
				stroke: "#002347",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.6614 56.5868C76.6614 56.5868 83.6969 46.0919 97.4864 51.4352",
				stroke: "#002347",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M111.536 54.4301C111.536 54.4301 118.733 47.6446 128.325 54.1185",
				stroke: "#002347",
				strokeWidth: .9,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96.4738 30.8792C96.4738 30.8792 105.339 27.8883 109.908 33.5073C116.028 41.0385 118.901 48.3246 126.02 50.2368C126.02 50.2368 128.374 24.6326 99.6314 22.3184L86.7949 26.8685L96.4836 30.8694L96.4738 30.8792Z",
				fill: "#023B79"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.0828 189.985L77.3966 190.887L77.2352 190.943C76.7366 191.1 76.6211 191.352 76.552 191.639L75.5307 195.59L72.4429 193.09L72.3404 193.008C72.3404 193.008 72.2541 192.934 72.1562 192.963L72.1556 192.963C72.0596 192.999 72.0359 193.111 72.0359 193.111L72.0034 193.237L71.1173 197.071L67.8504 194.558C67.6221 194.371 67.378 194.24 66.8849 194.415L66.723 194.467L64.0362 195.369L64.9254 198.017L66.5077 197.486C66.8402 197.371 66.9996 197.335 67.3239 197.544L67.4671 197.656L72.4032 201.769C72.4032 201.769 72.5633 201.902 72.74 201.844C72.9305 201.781 72.9789 201.576 72.9789 201.576L73.8686 198.058L73.8692 198.058L76.7741 200.298C76.7741 200.298 76.9407 200.433 77.1063 200.382C77.2841 200.328 77.3222 200.119 77.3222 200.119L78.7298 193.877L78.7754 193.702C78.85 193.381 79.047 193.284 79.3804 193.176L80.9636 192.644L80.0828 189.985Z",
				fill: "#F2B014"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78.5065 198.705L77.7361 202.114L74.3978 199.522L73.5849 202.757L79.1525 207.404C79.3313 207.524 79.4413 207.525 79.4919 207.51C79.6027 207.478 79.6455 207.397 79.6941 207.152L80.7238 200.858C80.8188 200.31 81.241 200.175 81.241 200.175L83.2787 199.491L82.3896 196.847L79.208 197.914C78.6284 198.108 78.5065 198.705 78.5065 198.705Z",
				fill: "#F2B014"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3710_46677",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0H312V356C312 364.837 304.837 372 296 372H16C7.16344 372 0 364.837 0 356V0Z",
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgScientist);
export default ForwardRef;
